import { isImageForViewer } from './isImage';

export const isViewable = (mime: string | undefined): boolean => {
  return !!mime && (isImageForViewer(mime) || mime === 'pdf');
};
